export default [
  {
    label: 'Canned Dashboard',
    value: 'canned'
  },
  {
    label: 'My Dashboards',
    value: 'userDashboards'
  },
  {
    label: 'Shared Dashboards',
    value: 'sharedDashboards'
  }
];
